import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import AuthView from "@/views/AuthView.vue";
import { useSettings } from "@/composables/settings";
import { getApiUrl } from "@/aws-configuration";
import { fetchAuthSession } from "@aws-amplify/core";
import { useCustomerIdRef, initClient } from "@ptx-autonomous/libs/api";
import { initFlightpathServiceClient } from "@ptx-autonomous/libs/flightpath-service-api";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			name: "home",
			component: HomeView,
		},
		{
			path: "/auth",
			name: "auth",
			component: AuthView,
		},
	],
});

router.beforeEach(async to => {
	function redirect() {
		if (to.name !== "auth") {
			return {
				name: "auth",
				query: { redirect: to.name?.toString() },
			};
		}
	}

	try {
		const { apiVersion, organizationId } = useSettings();
		const session = await fetchAuthSession();
		const customerId = useCustomerIdRef();

		// Redirect to auth page if no authentication
		if (!session.tokens?.idToken) {
			return redirect();
		}

		// Initialize HTTP clients
		initClient(false, "", "", getApiUrl(apiVersion.value));
		initFlightpathServiceClient(getApiUrl(apiVersion.value));

		const groups = session.tokens?.idToken?.payload[
			"cognito:groups"
		] as string[];

		// Admins can switch organization, use the organization id instead of the customer id
		if (groups.includes("FlightPathAdmin") && organizationId.value) {
			customerId.value = organizationId.value;
		}
		// Set customer id for regular users
		else {
			customerId.value = session.tokens?.idToken?.payload[
				"custom:accountid"
			] as string;
		}
	} catch (e: unknown) {
		return redirect();
	}
});

export default router;
